/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2025 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import React from "react";
import styled from "styled-components";
import { webComponentShim } from "components/shared/WebComponentShim";
import { AppHeaderHeight } from "components/shared/AppHeader";
import { devices } from "../Styles";

export const BannerHeight = "48px";

export const enum ButtonStyle {
  DEFAULT,
  BANNER,
}

const FixedBanner = styled.header`
  position: relative;
  top: ${AppHeaderHeight};
  box-sizing: border-box;
  height: ${BannerHeight};
  display: flex;
  flex-direction: row;
  flex: 1 1 0;
  width: 100%;
  align-items: center;
  justify-content: center;
  z-index: 2;
  padding: 14px 0px 16px var(--Spacing-spacing-100, 8px);
  background: var(--spectrum-global-color-indigo-400);

  ${devices.small} {
    align-items: center;
    gap: 10px;
    flex-direction: column;
    height: auto;
    padding: 10px 0px 12px var(--Spacing-spacing-100, 8px);
  }
`;

export const TextContainer = styled.div`
  color: white;
  font: normal normal 400 14px/18.2px adobe-clean;
`;

const Button = styled(webComponentShim("sp-button"))`
  border-color: white;
  color: white;
  &:hover {
    background: white;
    color: var(--spectrum-global-color-indigo-400);
  }
`;

export const PromotionBanner: React.FC<{
  isVisible?: boolean;
}> = ({ isVisible = false }) => {
  if (!isVisible) {
    return null;
  }
  return (
    <FixedBanner>
      <>
        <TextContainer>
          <span style={{ fontWeight: "bold" }}>{I18n.t("banner.text")}</span>
        </TextContainer>
      </>
      <div style={{ marginLeft: "10px" }}>
        <Button
          size="m"
          variant="secondary"
          quiet={false}
          onClick={() => {
            window.open(I18n.t("banner.link"), "_blank");
          }}
          aria-label={I18n.t("banner.text")}
        >
          {I18n.t("banner.cta")}
        </Button>
      </div>
    </FixedBanner>
  );
};
